<template>
  <div>
     <div class="row" v-if="editing">
      <div class="col-4">
        <label for="">{{ $t('insights.ui.timespan.label') }}</label>
        <select name="" class=form-control v-model="config.typeOfPeriod" id="">
          <option :value="'day'">{{ $t('insights.ui.timespan.day') }}</option>
          <option :value="'week'">{{ $t('insights.ui.timespan.week') }}</option>
        </select>
      </div>
      <div class="col-3">
        <label for="title-heartbeat">{{ $t('ui.title') }}</label>
        <input type="text" id="title-heartbeat" class="form-control" v-model="config.title">
      </div>

      <div class="col-3">
        <label for="">{{ $t('menu.workflows') }}</label>
        <div :key="wf.id" class="custom-control custom-checkbox "
             v-for="(wf,idx) in getWorkflows">
          <input v-model="config.filterWorkflows"
                 :value="wf.id"
                 type="checkbox"
                 :id="'wf' + idx +UID"
                 class="custom-control-input"
          >
          <label class="custom-control-label" :for="'wf' + idx+UID">
            <span>{{ wf.name }}</span>
          </label>
        </div>
      </div>
      <!--      <div class="col-xs-3">-->
      <!--        <label for="filter-on">Filter</label>-->
      <!--        <select name="" class="form-control" v-model="config.filterByKey" id="">-->
      <!--          <option :value="key" :key="key" v-for="key in getUniqueKeys">{{ getFormattedKey(key) }}</option>-->
      <!--        </select>-->
      <!--      </div>-->
    </div>
    <!--    <div v-if="editing" class="row">-->
    <!--      <div v-for="(shift,index) in config.shifts" class="form-group">-->
    <!--        <label :for="'from-'+index">{{ $t('ui.from') }}</label>-->
    <!--        <input :id="'from-'+index" type="number">-->

    <!--        <label :for="'from-'+index">{{ $t('ui.to') }}</label>-->
    <!--        <input :id="'from-'+index" type="number">-->
    <!--      </div>-->
    <!--      <a href="javascript:;" @click="addShift()" class="btn btn-primary">add shift</a>-->
    <!--    </div>-->
    <template v-if="!editing">
      <div class="row justify-content-md-center">

        <div class="col-1 text-center">

          <i @click="adjustStartDate('sub')" class="fal fa-chevron-square-left"></i>

        </div>
        <div class="col">
          <div class="text-center">
            <label for="filter-value" @click="setToday() ">

              <i v-show="!isAfterToday()"
                 data-toggle="tooltip" data-placement="top"
                 :title="config.typeOfPeriod =='day' ? $t('insights.setToday') : $t('insights.setThisWeek')"
                 style="cursor: pointer;font-size:16px"
                 :class='"far fa-calendar-"+config.typeOfPeriod'></i>
              {{ $t('ui.date.' + config.typeOfPeriod) }}

            </label>
            <p>{{ getFormattedPeriod }}


            </p>


          </div>
        </div>
        <div class="col-1 text-center">
          <i @click="adjustStartDate('add')" v-show="!isAfterToday()" class="fal fa-chevron-square-right"></i>
        </div>
      </div>
    </template>

    <div v-show="!editing" class="chart-container" :id="'comp-'+this._uid">

      <ComponentLoadSpinner :loading="loading"/>

      <BarChart style="width: 100%; height: 100%"
                :class="loading ? 'loading':''"
                :chartData="getChartData"
                :options="getOptions"/>

    </div>


  </div>


</template>

<script>
import BarChart from '@/components/insights/charts/barChart.js'
import {mapGetters} from "vuex";
import timeCalc from "@/mixins/timeCalc";
import generalMethods from "@/mixins/insights/generalMethods";
import chartColors from "@/mixins/insights/chartColors";
import axios from "axios";
import ComponentLoadSpinner from "@/components/general/ComponentLoadSpinner";

export default {
  components: {
    BarChart,
    ComponentLoadSpinner
  },
  mixins: [timeCalc, generalMethods, chartColors],
  props: ['editing'],
  data() {

    return {
      periodicLogs: null,
      loading: true,
      interval: null,
      UID: this._uid,
      config: {
        typeOfPeriod: 'day',
        startDate: null,
        filterByKey: null,
        filterWorkflows: [],
        filterByValue: null,
        shifts: [],
        hideDataset: []
      }
    }
  },
  computed: {
    ...mapGetters('users', ['getClaims', 'getMe']),
    ...mapGetters('workflows', ['getWorkflowName', 'getWorkflowColor', 'getWorkflows']),
    getFormattedPeriod() {
      if (this.config.typeOfPeriod === 'day') {
        return this.config.startDate ? moment(this.config.startDate).format('DD-MM-YYYY') : moment().format('DD-MM-YYYY')
      } else if (this.config.typeOfPeriod === 'week') {
        let startDay = this.config.startDate ? moment(this.config.startDate).startOf('isoWeek') : moment().startOf('isoWeek')
        return startDay.format('DD-MM-YYYY') + ' - ' + startDay.endOf('isoWeek').format('DD-MM-YYYY')
      }
      return ''
    },
    getOptions() {
      const self = this
      const unitFormat = self.config.typeOfPeriod == 'day' ? 'minute' : 'day'
      const formatting = self.config.typeOfPeriod == 'day' ? "HH:mm" : "DD-MM"
      return {
        ...this.generalChartOptions,
        scales: {
          offset: true, // IF this is set to false, it will not display the last bar!
          xAxes: [
            {
              gridLines: {
                display: false
              },
              offset: true, // IF this i
              stacked: false,
              type: 'time',
              ticks: {
                min: self.config.typeOfPeriod == 'day' ? '00:00' : moment(this.config.startDate).startOf('isoWeek').toDate(),
                max: self.config.typeOfPeriod == 'day' ? '23:59' : moment(this.config.startDate).endOf('isoWeek').toDate(),
              },
              time: {
                isoWeekday: true,
                unit: unitFormat,
                // round: unitFormat,
                // stepSize: 1,
                displayFormats: {
                  millisecond: formatting, //I have tried without the 'a' too, same result
                  second: formatting,
                  minute: formatting,
                  hour: formatting,
                  day: formatting,
                  week: formatting,
                }
              }
            },
          ],
          yAxes: [{
            stacked: false,
            ticks: {
              maxTicksLimit: self.config.typeofPeriod === 'day' ? 6 : 10,
              beginAtZero: true,
              autoSkip: true,
              stepSize: 2,
              callback: function (label, index, labels) {
                return label
              }
            }
          }],
        },
        //This will show money in tooltip with format of $xx.xx
        tooltips: {
          intersect: false,
          // cornerRadius: 0,
          //
          // backgroundColor: 'black',
          // titleColor: 'white',
          // titleFont: {},
          // bodyColor: 'red',
          // caretSize: 20,
          // caretPadding: 5,
          // padding: 10,

          callbacks: {
            title: function (tooltip) {
              return moment(tooltip[0].label).format('DD-MM-YYYY HH:mm')
            },
            label: function (tooltipItem) {
              return tooltipItem.value     //tooltipItem.value
            }
          }
        },

        plugins: {

          datalabels: {
            color: 'black',
            anchor: 'start',
            align: 'bottom',
            font: {
              // weight: 'bold',
              size: 20
            },
            offset: -50,

            display: function (ctx) {
              return false
              return ctx.datasetIndex > 0 //ctx.chart.$totalizer.utmost;
            },
            formatter: (value, ctx) => {
              return self.getHoursFromMilliseconds(value.y, false) > 0 ? self.getHoursFromMilliseconds(value.y, false) + '' : ' '
            },
          }
        },
        responsive: true,
        maintainAspectRatio: false,

      }
    },

    getUniqueValues() {
      // should loop and get values if type
      let mappedValues = _.map(this.jobs, (job) => {
        if (job[this.config.filterByKey] && job[this.config.filterByKey].length && typeof job[this.config.filterByKey] == "object") {
          return _.uniq(job[this.config.filterByKey])
        }
        return job[this.config.filterByKey]
      })
      let res = _.flattenDeep(mappedValues).filter(val => {
        return val
      })
      return [...new Set(res)].sort();

    },
    getChartData() {
      let logs = _.clone(_.orderBy(this.periodicLogs, ['timestamp.value'], ['asc']))
      logs = logs.map((log, id) => {
        log.workflow = this.getWorkflowName(log.workflowId)
        log.timestamp = moment(log.timestamp.value).startOf(this.config.typeOfPeriod == 'day' ? 'minute' : 'day').toDate()
        log.color = this.getWorkflowColor(log.workflowId)
        return log
      })
      let logsByWorkflow = _.groupBy(logs, 'workflowId')
      let datasets = []
      _.each(logsByWorkflow, (logs, index) => {
        let grouppedLogsByTimeStamp = _.groupBy(logs, 'timestamp')
        let data = this.createDatasetData(grouppedLogsByTimeStamp, index)
        datasets.push({
          // barThickness: 5,
          label: this.getWorkflowName(index),
          backgroundColor: this.getWorkflowColor(index),
          data,
          hidden: _.includes(this.config.hideDataset, this.getWorkflowName(index)),
          stack: `stack 0 ${index}`,
        })
      })

      return {
        labels: [],
        datasets
      }
    },
  },
  methods: {
    setToday() {
      if (!this.isAfterToday(moment(this.config.startDate))) {
        this.config.startDate = moment().startOf(this.config.typeOfPeriod).toDate()
      }
    },
    createDatasetData(logs, index) {
      return _.chain(logs).map((log, id) => {
        return {
          date: id,
          t: id,
          y: _.sumBy(log, l => {
            return parseFloat(l.amountProduced)
          })
        }
      }).value()
    },
    addShift() {
      if (!this.config.shifts) {
        this.config.shifts = []
      }
      this.config.shifts.push({
        from: new Date(),
        to: new Date(),
        color: null
      })
    },
    isAfterToday(date) {
      if (!date) {
         date = moment(this.config.startDate).add(1, this.config.typeOfPeriod).endOf(this.config.typeOfPeriod)
      }

      return date.isAfter(moment(), this.config.typeOfPeriod == 'day' ? 'day' : 'week')
    },
    adjustStartDate(type) {

      if (type === 'add') {
        let newDate = moment(this.config.startDate).add(1, this.config.typeOfPeriod)
        if (this.isAfterToday(newDate)) {

          return false
        }
         this.config.startDate = newDate.toDate()
      } else {
        this.config.startDate = moment(this.config.startDate).subtract(1, this.config.typeOfPeriod).toDate()
      }
    },
    setInterval() {
      if (this.config.typeOfPeriod === 'day' && moment().isSame(this.config.startDate, 'day')) {
        if (!this.interval) {
          this.interval = setInterval(() => {
            if (!document.hidden) {
              this.getData();
            }
          }, 1000 * 60)
        }
      } else {
        clearInterval(this.interval)
        this.interval = null
      }
    },
    async getData() {
      if (this.editing) {
        return
      }
      if (this.abortController) {
        try {
          this.abortController.abort()
        } catch {
        }
      }
      let authToken = this.$FirebaseAuth.getIdToken()
      // if (!this.config.startDate) {
      //   this.config.startDate = moment().startOf('day').toDate()
      // }
      const self = this
      this.loading = true
      try {

        let startDate = this.config.typeOfPeriod === 'day' ? moment(this.config.startDate).startOf('day') : moment(this.config.startDate).startOf('isoWeek')
        let endDate = this.config.typeOfPeriod === 'day' ? moment(this.config.startDate).endOf('day') : moment(this.config.startDate).endOf('isoWeek')

        let query = `fromDate=${moment(startDate).format('YYYY-MM-DD')}`
        query += `&toDate=${moment(endDate).format('YYYY-MM-DD')}`
        try {
          query += `&workflows=${this.config.filterWorkflows.join(',')}`
        } catch (e) {
          console.log(e)
        }
        this.abortController = new AbortController();
        axios.get('https://europe-west1-performance-management-tool.cloudfunctions.net/http_api/hardwareLogs?' + query,
            {
              signal: this.abortController.signal,
              headers: {'motivate-auth': authToken}
            })
            .then((res) => {

              self.periodicLogs = res.data
              self.loading = false
            })
            .catch(e => {
              if (e.response && e.response.data.code === 404) {
                this.$swal({
                  title: 'Error',
                  text: e.message,
                  cancelButtonText: this.$root.$t('ui.cancel'),
                  showCancelButton: true,
                  toast: true,
                  target: '#comp-' + this._uid,

                  position: 'bottom-right'

                })
              }
              if (e.message == 'canceled' && this.abortController) {
                self.loading = true
              } else {
                self.loading = false
              }
            })
        this.setInterval()


      } catch (e) {
        console.error(e)
      }
      return false
    },

  },
  watch: {
    'config.startDate'(newV) {
      this.getData()
    },
    'config.filterWorkflows'(newV) {
      this.getData()
    }
  },
  created() {
    if(this.config.typeOfPeriod == 'day'){
    this.config.startDate = moment().startOf(this.config.typeOfPeriod).toDate()
    this.config.endDate = moment().endOf(this.config.typeOfPeriod).toDate()
    }else{
      this.config.startDate = moment().startOf('isoWeek').toDate()
      this.config.endDate = moment().endOf('isoWeek').toDate()
    }
    this.getData()


  },
  mounted() {

    if (!this.config.filterWorkflows) {
      this.config.filterWorkflows = []
    }



    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
  },

  beforeRouteLeave(to, from, next) {
    clearInterval(this.interval)
    this.interval = null
    if (this.abortController) {
      this.abortController.abort()

    }
    next()
  },
  beforeDestroy() {
    clearInterval(this.interval)
  }
}
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/insights/_generalStylingCharts.scss";


</style>